"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSortFieldToJSON = exports.AdSortFieldFromJSONTyped = exports.AdSortFieldFromJSON = exports.AdSortField = void 0;
/**
 * Field by which to sort list of ads.
 * @export
 */
exports.AdSortField = {
    CreatedAt: 'CREATED_AT',
    Id: 'ID',
    Name: 'NAME',
    Status: 'STATUS',
    UpdatedAt: 'UPDATED_AT'
};
function AdSortFieldFromJSON(json) {
    return AdSortFieldFromJSONTyped(json, false);
}
exports.AdSortFieldFromJSON = AdSortFieldFromJSON;
function AdSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdSortFieldFromJSONTyped = AdSortFieldFromJSONTyped;
function AdSortFieldToJSON(value) {
    return value;
}
exports.AdSortFieldToJSON = AdSortFieldToJSON;
